import { RELATIONSHIP_SUBTITLES } from '@/components/CorporateUsers/Onboarding/constants';
import { TABS } from './constants';

/** The banner eyebrow: the carrier's organization_carrier_statuses `relationship`, as the onboarding cards name it. */
export const eyebrowFor = (relationship) => RELATIONSHIP_SUBTITLES[relationship] || 'Carrier';

/** The carrier page's tabs for the carrier's `relationship`: Flex Centers (OWNED) also get the `flexCenterOnly` ones. */
export const tabsFor = (relationship) => TABS.filter((tab) => !tab.flexCenterOnly || relationship === 'OWNED');
